import React, { lazy, Suspense, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// IMG Y IMPORTACIONES
import useNews from "../hooks/useNews";
import { Helmet, HelmetProvider } from "react-helmet-async";

const ShareSocial = lazy(() => import("../components/news/ShareSocial"));
const CardNews = lazy(() => import("../components/news/CardNews"));
const NavTensoNews = lazy(() => import("../components/nav/NavTensoNews"));
const CardVideo = lazy(() => import("../components/news/CardVideo"));

const Noticias = () => {
  const params = useParams();
  const { noticia, obtenerNoticia, newsVideo, news } = useNews();
  const [busqueda, setBusqueda] = useState();
  const [titlePage, setTitlePage] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const newTitle = params.id.replaceAll("-", " ");
    obtenerNoticia({ title: newTitle });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setBusqueda(noticia.category);
  }, [noticia]);

  //Title de pageHtml
  setTimeout(() => {
    setTitlePage(noticia?.title);
  }, 500);
  useEffect(() => {
    document.title = titlePage ? titlePage : "Tensolite";
  }, [titlePage]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet prioritizeSeoTags>
          <title>{noticia.title}</title>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content={`http://tensolite.com/Noticias-multimedia/${noticia.title}`}
          />
          <meta property="og:title" content={noticia?.title} />
          <meta property="og:description" content={noticia?.top} />
          <meta property="og:image" content="/logo192.png" />
          {/* Twitter */}
          <meta property="twitter:card" content="summary_large_image" />
          <meta
            property="twitter:url"
            content={`http://tensolite.com/Noticias-multimedia/${noticia.title}`}
          />
          <meta property="twitter:title" content={noticia?.title} />
          <meta property="twitter:description" content={noticia?.top} />
          <meta property="twitter:image" content="/logo192.png" />

          {/* Google Tag Manager (noscript) */}

          {/* End Google Tag Manager (noscript) */}
          <script type="application/ld+json">
            {`
            "@context": "https://schema.org",
            "@type": "article" ,
            "author": "Tensolite SA",
            "name": ${noticia.title},
            "description": ${noticia.top},
            "about": ${noticia.category},           
       `}
          </script>
        </Helmet>
      </HelmetProvider>
      <Suspense fallback={<div> </div>}>
        <NavTensoNews />

        {/* BODY */}

        <div className="container">
          <ShareSocial noticia={noticia} />
          <div>
            {/* Seccion superior */}
            <div id="noticia-video">
              <div className="mt-5 video-principal">
                <iframe
                  className=""
                  srcDoc={`
                              <style>
                                  body, .full {
                                      width: 100%;
                                      height: 100%;
                                      margin: 0;
                                      position: absolute;
                                      display: flex;
                                      justify-content: center;
                                      object-fit: cover;
                                  }
                              </style>
                              <a
                                  href='${noticia.video}?autoplay=1'
                                  class='full'
                              >
                                  <img
                                      src='http://img.youtube.com/vi/${noticia.video?.replace(
                                        "https://www.youtube.com/embed/",
                                        ""
                                      )}/0.jpg'
                                      class='full'
                                  />
                                  <svg
                                      version='1.1'
                                      viewBox='0 0 68 48'
                                      width='68px'
                                      style='position: relative;'
                                  >
                                      <path d='M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z' fill='#f00'></path>
                                      <path d='M 45,24 27,14 27,34' fill='#fff'></path>
                                  </svg>
                              </a>
                          `}
                  style={{
                    maxWidth: "1399px",
                    width: "100%",
                    aspectRatio: "16/9"
                  }}
                  allow="autoplay *; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  frameorder="0"
                ></iframe>
              </div>
              {noticia.lastNewsVideos !== false && (
                <div className="text-video display-videos">
                  <div className="titulo-seccion-video noticias-hr">
                    <p className="titulo-roboto">Últimos videos</p>
                  </div>
                  <div className="video-destacado">
                    <div id="videos-recomendados">
                      {loading ? (
                        <>
                          <CardVideo loading={loading} />
                          <CardVideo loading={loading} />
                          <CardVideo loading={loading} />
                        </>
                      ) : (
                        <>
                          {newsVideo
                            .slice(0, 3)
                            .map(
                              (noticia, index) =>
                                noticia.deleted === false &&
                                noticia.visible === true &&
                                noticia.publish === true && (
                                  <CardVideo loading={loading} key={index} noticia={noticia} />
                                )
                            )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Seccion inferior */}
            <div id="noticia-video">
              <div>
                <section className="info-producto-multimedia">
                  <div id="tarjeta-azul">
                    <div className="texto-slider">
                      <p>{noticia.category}</p>
                    </div>
                    <div className="title-info-noticias py-3">
                      <h3 className="titulo-multimedia">{noticia.title}</h3>
                    </div>
                  </div>
                  <div className="card-ventajas mb-4">
                    <p>{noticia.top}</p>
                    {/* <p className=" text-multimedia">Diciembre 14, 2020</p> */}
                  </div>
                </section>
                <div className="cards-noticias card-multimedia">
                  <article className="info-card uno">
                    <h4>{noticia.titleBody}</h4>
                    <p id="news-tiny-editor" dangerouslySetInnerHTML={{ __html: noticia.body }}></p>
                  </article>
                </div>
              </div>
              {noticia.lastNewsVideos !== false && (
                <div className="text-video display-videos2">
                  <div className="titulo-seccion-video noticias-hr">
                    <p className="titulo-roboto">Últimos videos</p>
                  </div>
                  <div className="video-destacado">
                    <div id="videos-recomendados">
                      {newsVideo
                        .slice(0, 3)
                        .map(
                          (noticia, index) =>
                            noticia.deleted === false &&
                            noticia.visible === true &&
                            noticia.publish === true && <CardVideo key={index} noticia={noticia} />
                        )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {noticia.newsCategory !== false && (
              <>
                <div className="seccion-mas-noticias">
                  <div className="title-noticias ">
                    <h3>Últimas noticias de Videos</h3>
                  </div>
                </div>
                <div className="seccion-cards-noticias ">
                  <div id="seccion-noticas">
                    <div className="">
                      <div className="masonry">
                        {loading ? (
                          <>
                            <CardNews loading={true} tensoblog={true} />
                            <CardNews loading={true} tensoblog={true} />
                          </>
                        ) : (
                          <>
                            {news.map(
                              (noticia, index) =>
                                noticia.category === busqueda &&
                                noticia.deleted === false &&
                                noticia.visible === true &&
                                noticia.publish === true && (
                                  <CardNews key={index} noticia={noticia} />
                                )
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </Suspense>
    </>
  );
};
export default Noticias;
